import { render, staticRenderFns } from "./BetItem.vue?vue&type=template&id=132237e2&scoped=true"
import script from "./BetItem.vue?vue&type=script&lang=js"
export * from "./BetItem.vue?vue&type=script&lang=js"
import style0 from "./BetItem.vue?vue&type=style&index=0&id=132237e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132237e2",
  null
  
)

export default component.exports